import { createContext, useCallback, useContext, useState } from 'react';

import { IEntityJsonViewerProps } from '@monetize/types/app';

const defaultContext = {
  drawerData: null,
};

export type EntityJsonViewerOpenOptions = Partial<IEntityJsonViewerProps>;

type EntityJsonViewerType = {
  drawerData: null | IEntityJsonViewerProps;
  openDrawer: (options: EntityJsonViewerOpenOptions) => void;
  closeDrawer: () => void;
};

const EntityJsonViewerContext = createContext<EntityJsonViewerType>(
  defaultContext as unknown as EntityJsonViewerType,
);

export const useEntityJsonViewer = () => useContext(EntityJsonViewerContext);

const defaultDrawerData: IEntityJsonViewerProps = {
  title: 'View Entity JSON',
  description: '',
  json: undefined,
};

export const useEntityJsonViewerProvider = () => {
  const [drawerData, setDrawerData] = useState<IEntityJsonViewerProps | null>(
    null,
  );

  const closeDrawer = useCallback(() => {
    setDrawerData(null);
  }, []);

  const openDrawer = useCallback(
    (options: EntityJsonViewerOpenOptions) => {
      setDrawerData({
        ...defaultDrawerData,
        ...options,
        onClose: options.onClose ?? closeDrawer,
      });
    },
    [closeDrawer],
  );

  return {
    drawerData,
    openDrawer,
    closeDrawer,
  };
};

export const EntityJsonViewerProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const data = useEntityJsonViewerProvider();
  return (
    <EntityJsonViewerContext.Provider value={data}>
      {children}
    </EntityJsonViewerContext.Provider>
  );
};
